import { toast, TypeOptions } from "react-toastify";

const notify = (message: string, type: TypeOptions = "dark") => {
  toast(message, { type: type });
};

export default notify;
